export const MODULES = [
  { key: "dashboard", label: "Painel" },
  { key: "grupos", label: "Grupos & Líderes" },
  { key: "frequencia", label: "Frequência" },
  { key: "aniversariantes", label: "Aniversariantes" },
  { key: "oracoes", label: "Pedidos de Oração" },
  { key: "calendario", label: "Calendário" },
  { key: "formacao", label: "Estudos & Formação" },
  { key: "atendimento", label: "Atendimento" },
  { key: "metas", label: "Metas & Compromissos" },
  { key: "relatorios", label: "Relatório Pastoral" },
  { key: "certificados", label: "Certificados" },
  { key: "pesquisas", label: "Pesquisas" },
  { key: "celebracao", label: "Celebração" },
  { key: "contatos", label: "Contatos" },
];

export function moduleLabel(key) {
  return MODULES.find((m) => m.key === key)?.label || key;
}

// digits-only phone with Brazil country code for wa.me links
export function waLink(phone, text) {
  let digits = (phone || "").replace(/\D/g, "");
  if (!digits) return null;
  if (digits.length <= 11) digits = "55" + digits;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

// Google Maps search link for a group location (address + neighborhood)
export function mapsUrl(...parts) {
  const query = parts.filter(Boolean).join(", ").trim();
  if (!query) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

// Return an embeddable player URL for YouTube/Vimeo links, or null if not embeddable
export function videoEmbed(url) {
  if (!url) return null;
  const u = url.trim();
  let m = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{11})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return `https://player.vimeo.com/video/${m[1]}`;
  return null;
}
